module.exports = __webpack_public_path__ + "img/ingredienten-pittige-koreanse-speklapjes.22fcf965.jpeg";